import userReducer from "./reducers/user"
import activeGameIdReducer from "./reducers/activeGameId"
import activeEventReducer from "./reducers/activeEvent"
import { combineReducers } from "redux"

const allReducers = combineReducers({
    user: userReducer,
    activeGameId: activeGameIdReducer,
    activeEvent: activeEventReducer
})
  
const appReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        state = undefined;
      }
    return allReducers(state, action);
}
  
export default appReducer;